<template>
  <div v-if="cart.payment_methods && cart.payment_methods.length" id="cart-payments" class="float-none mb-2 text-right">
    <p v-for="(payment_method, k) in cart.payment_methods" :key="k">
      {{ payment_method.name }}:
      <button class="btn btn-link text-danger pt-0" @click="removeCartPayment(payment_method)" :disabled="removing[payment_method.id]"><i class="fas fa-times"></i></button>
      <span class="amount">{{ payment_method.amount | numberToRs }}</span>
    </p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SaleCartPaymentMethods',
  props: [
    'cart'
  ],
  data () {
    return {
      removing: {}
    }
  },
  methods: {
    removeCartPayment (cartPayment) {
      this.removing[cartPayment.id] = true

      let postData = {
        id: cartPayment.id,
        include_cart: true
      }

      axios.delete(process.env.URLS_PUBLIC_API + '/cart/' + this.$parent.cart.id + '/payment_methods', {
        data: postData
      }).then((response) => {
        this.$parent.cart = response.data.data.cart

        setTimeout(() => {
          this.$parent.setPaneHeights()
        }, 100)
      }).catch(error => {
        this.$toast.error('Failed to remove the payment method.' + typeof error.response !== 'undefined' && typeof error.response.data.message !== 'undefined' ? error.response.data.message : null)
      }).finally(() => {
        this.removing[cartPayment.id] = false
      })
    }
  }
}
</script>

<style scoped>
p {
  font-size: 1.1rem;
}
p:last-child {
  margin-bottom: 0 !important;
}
.amount {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/sale/partials/CartPaymentMethods.vue